export interface Article {
  id: string;
  title: string;
  excerpt: string;
  category: '炼丹' | '针灸' | '功法' | '总览';
  level: string;
  tag: string;
  cover: string;
  date: string;
  readTime: string;
  content: string[];
}

export const articles: Article[] = [
  {
    id: 'dan-lu-ru-men',
    title: '天才医仙漫画炼丹体系入门：从一品丹到九转金丹的晋级路线',
    excerpt:
      '炼丹并非简单的火候与药材堆叠，漫画里每一炉丹药都对应固定的品阶与药园体系。本文从一品丹讲到九转金丹，梳理主角炼丹之路的完整晋级逻辑。',
    category: '炼丹',
    level: '丹炉境',
    tag: '炼丹晋级',
    cover:
      'https://readdy.ai/api/search-image?query=%E5%8F%A4%E9%A3%8E%E6%B0%B4%E5%A2%A8%E4%B8%B9%E7%82%89%20%E9%9D%92%E7%A2%A7%E5%8F%A4%E7%81%B0%E4%B8%B9%E7%82%89%E5%8D%87%E8%85%BE%E6%B0%94%E6%81%AF%2C%20%E8%8D%AF%E7%81%AB%E8%8D%89%E8%8D%AF%E6%9D%90%E7%8E%AF%E7%BB%95%2C%20%E5%9B%BD%E7%94%BB%E5%A2%A8%E9%9F%B5%20%E6%9A%96%E9%87%91%E8%89%B2%E5%85%89%E6%99%95%2C%20%E9%AB%98%E8%A7%84%E6%A0%BC%E7%A7%91%E5%B9%BB%E6%85%A2%E7%94%BB%E9%A3%8E%E6%A0%BC&width=800&height=560&seq=article-danlu-01&orientation=landscape',
    date: '2026-08-12',
    readTime: '8 分钟',
    content: [
      '在《天才医仙漫画》的世界观里，炼丹并非只靠一口好锅。主角从初入丹道时连药性都分不清，到后来能一炉炼出九转金丹，靠的是"药园等级、火候把控、丹方传承"三者层层递进的体系设定。',
      '漫画把丹药划分成一品到九转的完整品阶。一品丹多为辅助修行的基础药，二品到四品开始涉及疗伤与增气，五品以上则进入能逆改经脉的"通脉类丹"，而九转金丹更是主角突破医仙之境的关键道具。每一品都对应固定的灵药等级与药园产出，这正是读者理清升级脉络最重要的锚点。',
      '主角的炼丹晋级有一条清晰的"火候曲线"：先用凡火熟悉丹性，再以真气催动文火温养，最后引入药园灵火淬炼丹胚。每一次火候升级，都伴随一炉更高品阶的丹药问世，也让主角在医仙之路上站得更稳。',
      '若想快速理解这套体系，建议先记住一条主线：药材等级决定丹药上限，火候掌握决定成丹率，丹方传承决定能走多远。三者在漫画里环环相扣，共同撑起"炼丹"这条最重要的修炼支线。',
    ],
  },
  {
    id: 'zhen-jiu-jing-mai',
    title: '针灸十二正经与奇经八脉在漫画中的设定解析',
    excerpt:
      '针灸是主角最核心的技能。漫画将十二正经与奇经八脉做了具象化处理，银针如何通脉、如何引气，本文逐一拆解其中设定。',
    category: '针灸',
    level: '通脉境',
    tag: '针灸通脉',
    cover:
      'https://readdy.ai/api/search-image?query=%E5%8F%A4%E9%A3%8E%E9%93%B6%E9%92%88%E7%BB%86%E5%86%99%20%E7%94%BB%E5%B1%95%E9%92%88%E7%81%B8%E4%BA%BA%E4%BD%93%E7%BB%8F%E8%84%89%E5%85%89%E7%82%B9%2C%20%E7%8E%89%E8%8B%8D%E7%BB%BF%E8%89%B2%E8%84%89%E7%BB%9C%E6%98%BE%E8%80%8C%E6%98%93%E8%A7%81%2C%20%E5%9B%BD%E7%94%BB%E5%A2%A8%E9%9F%B5%20%E6%B8%A9%E6%9A%96%E5%85%89%E6%98%8E%2C%20%E9%AB%98%E8%A7%84%E6%A0%BC%E6%85%A2%E7%94%BB%E9%A3%8E%E6%A0%BC&width=800&height=560&seq=article-zhenjiu-01&orientation=landscape',
    date: '2026-08-10',
    readTime: '7 分钟',
    content: [
      '在漫画设定里，针灸不是简单扎几下，而是"以针引气、以脉通神"的核心修行方式。主角的银针既能疏通经脉里的淤塞之气，也能在战斗与疗伤中成为攻守一体的手段。',
      '作者把十二正经与奇经八脉做了可视化处理：每条经脉在人物体内都像一条发光的通道，而银针则是撬动这些通道的"钥匙"。通脉境之前，主角只能在表层穴位行针；进入通脉境后，才开始真正触碰奇经八脉，这也成为他跨越凡人界限的分水岭。',
      '值得留意的是，漫画将针灸与"气"做了强绑定。针尖所到之处，真气随之引导，既能救人也能伤人。这种"医武同源"的设定，让针灸从单纯的医术升级为足以支撑主角走完整条医仙之路的复合能力。',
      '理解针灸体系的关键词只有三个：穴位、经脉、真气。它们像三根相互咬合的齿轮，随着主角境界提升而不断转动，最终织成一张覆盖全身的疗愈网络。',
    ],
  },
  {
    id: 'gong-fa-jin-jie',
    title: '功法进阶全览：主角每一层境界对应的功法与心法',
    excerpt:
      '从淬体到医仙，主角在每一境界都有对应的功法与心法作为支撑。本文按境界顺序，逐一列出并解释各阶段核心功法的作用。',
    category: '功法',
    level: '聚气境',
    tag: '功法心法',
    cover:
      'https://readdy.ai/api/search-image?query=%E5%8F%A4%E9%A3%8E%E5%8A%9F%E6%B3%95%E5%BF%83%E6%B3%95%20%E4%BF%AE%E7%82%BC%E6%89%93%E5%9D%90%E5%91%A8%E8%BA%AB%E7%8E%84%E6%B0%94%E7%BC%AD%E7%BB%95%2C%20%E9%87%91%E7%BB%85%E6%96%87%E5%AD%97%E8%AE%A1%E6%95%B0%E7%8E%AF%2C%20%E5%9B%BD%E7%94%BB%E5%A2%A8%E9%9F%B5%20%E6%B8%A9%E6%9A%96%E6%B7%B1%E6%B2%89%E8%89%B2%E8%B0%83%2C%20%E9%AB%98%E8%A7%84%E6%A0%BC%E6%85%A2%E7%94%BB%E9%A3%8E%E6%A0%BC&width=800&height=560&seq=article-gongfa-01&orientation=landscape',
    date: '2026-08-08',
    readTime: '9 分钟',
    content: [
      '功法和心法是支撑主角从凡人走向医仙的"内功骨架"。漫画里，功法决定一个人能吸收多少真气，心法则决定他能驾驭多强的力量，两者必须同步精进。',
      '淬体境以固本培元的入门功法为主，讲究夯实根基；进入聚气境后，主角开始修炼能凝聚真气的核心心法，这也是他第一次能借助真气疗伤；通脉境则搭配通脉类功法，专门打通经脉壁垒。',
      '到丹炉境与灵针境，功法开始与炼丹、针灸深度绑定——炼丹需要控火的心法，针灸需要引气的功法，彼此不再孤立。这种"功法为器、医术为用"的设计，让主角的修炼不再只是力量堆叠，而是真正走向医仙之路。',
      '所以解读功法体系时，不能只看境界名称，更要看它连接了哪一门技艺。理解这一层，就能看懂主角为什么总能"越级"救人——因为他的每一层功法都同时服务于医术。',
    ],
  },
  {
    id: 'yi-xian-zhi-lu',
    title: '医仙之路升级脉络：从凡人到医仙的六大境界详解',
    excerpt:
      '淬体、聚气、通脉、丹炉、灵针、医仙——漫画将医仙之路划分为六大境界。本文按顺序详解每个境界的晋级条件与能力跃升。',
    category: '总览',
    level: '医仙境',
    tag: '境界脉络',
    cover:
      'https://readdy.ai/api/search-image?query=%E4%BB%99%E4%BA%BA%E4%BF%AE%E7%82%BC%E9%98%B6%E6%A2%AF%E4%BA%91%E9%9B%BE%E5%B1%B1%E5%B3%B0%20%E4%B9%9D%E5%B1%82%E4%BB%99%E9%98%B6%E5%85%89%E6%9D%9F%2C%20%E5%8F%A4%E9%A3%8E%E5%B1%B1%E6%B0%B4%E5%A2%A8%E9%9F%B5%2C%20%E6%9A%96%E9%87%91%E8%89%B2%E4%BB%99%E6%B0%94%E4%B8%8E%E7%8E%89%E9%9D%92%E7%BB%BF%E4%BA%A4%E7%BB%87%2C%20%E9%AB%98%E8%A7%84%E6%A0%BC%E6%85%A2%E7%94%BB%E9%A3%8E%E6%A0%BC&width=800&height=560&seq=article-jingjie-01&orientation=landscape',
    date: '2026-08-05',
    readTime: '10 分钟',
    content: [
      '《天才医仙漫画》把"医仙之路"清晰划分为六大境界：淬体、聚气、通脉、丹炉、灵针、医仙。每一境界既是力量的跃升，也是医术能力的质变，读懂这条线就等于抓住了整部漫画的主轴。',
      '淬体境是起点，主角通过强健体魄打好基础；聚气境开始凝聚真气，能运用最基础的疗愈之气；通脉境是分水岭，银针正式能作用于经脉，主角由此从"医人"跨向"医灵"。',
      '丹炉境与灵针境则把炼丹、针灸两大医术推向极致——丹炉境能炼出扭转伤势的灵丹，灵针境能一针引气、救人于危。最后的医仙境，是医术与修为合一，主角真正拥有"起死回生"的能力。',
      '六个境界并非简单的数值提升，而是环环相扣的能力解锁。每一关都以前一境界的积淀为前提，这也是作者设置升级脉络的高明之处：读者看主角一步步变强的同时，也看懂了整套医仙体系的运转逻辑。',
    ],
  },
  {
    id: 'yao-yuan-ti-xi',
    title: '漫画中的药园体系：灵药等级与炼丹材料的对应关系',
    excerpt:
      '丹药品阶背后是完整的药园与灵药体系。本文梳理灵药等级、药园产地与炼丹材料之间的对应关系，帮你看懂每一炉丹的出处。',
    category: '炼丹',
    level: '丹炉境',
    tag: '药园灵药',
    cover:
      'https://readdy.ai/api/search-image?query=%E5%8F%A4%E9%A3%8E%E8%8D%AF%E5%9B%AD%E7%81%B5%E8%8D%89%20%E7%8E%89%E9%9D%92%E7%BB%BF%E8%89%B2%E7%81%B5%E8%8D%89%E5%85%89%E8%8A%92%E5%9B%AD%2C%20%E8%8D%AF%E7%94%B0%E6%95%B4%E9%BD%90%E6%8E%92%E5%88%97%2C%20%E5%9B%BD%E7%94%BB%E5%A2%A8%E9%9F%B5%20%E6%9A%96%E6%B4%81%E6%B8%85%E6%96%B0%2C%20%E9%AB%98%E8%A7%84%E6%A0%BC%E6%85%A2%E7%94%BB%E9%A3%8E%E6%A0%BC&width=800&height=560&seq=article-yaoyuan-01&orientation=landscape',
    date: '2026-08-02',
    readTime: '6 分钟',
    content: [
      '药园体系是支撑炼丹支线的"后勤底座"。漫画把灵药划分为与丹药品阶严格对应的等级：低品灵药供给一品丹，高品灵药才够资格炼九转金丹。',
      '每一座药园都有专属的产地属性——有的药园灵气充沛，产出通脉类灵草；有的则偏寒偏热，专供火性丹药。主角的升级之路，很大一部分就是在不断寻找并培育更高等级的药材。',
      '理解药园体系的关键，是记住"丹方—灵药—药园"的三层对应：一张高阶丹方，必然指向一组特定灵药，而灵药的来源又被药园等级锁死。这三层像一道锁链，把炼丹的每一次突破都牢牢锚定在资源积累上。',
      '对读者而言，看药园相关的剧情时，只要抓住"这株灵药能炼什么品阶的丹"这一个问题，就能快速跟上主角在炼丹线的所有转折。',
    ],
  },
  {
    id: 'ming-ci-jie-du',
    title: '如何看懂天才医仙漫画中的医术设定与名词',
    excerpt:
      '真气、通脉、品阶、境界……漫画里术语不少。本文用大白话解释这些设定名词，帮你零门槛看懂整部作品的核心设定。',
    category: '总览',
    level: '入门',
    tag: '设定名词',
    cover:
      'https://readdy.ai/api/search-image?query=%E5%8F%A4%E7%B1%8D%E5%8D%B7%E8%BD%B4%E4%B8%AD%E5%8C%BB%E8%8D%89%E8%8D%AF%E7%9B%B8%E5%86%8C%20%E7%8E%84%E9%BB%84%E7%BA%B8%E5%8D%B7%E4%B8%8E%E7%AC%A6%E6%96%87%2C%20%E5%9B%BD%E7%94%BB%E5%A2%A8%E9%9F%B5%20%E6%9A%96%E9%87%91%E4%B8%8E%E7%8E%89%E9%9D%92%E7%BB%BF%E5%AF%B9%E6%AF%94%2C%20%E9%AB%98%E8%A7%84%E6%A0%BC%E6%85%A2%E7%94%BB%E9%A3%8E%E6%A0%BC&width=800&height=560&seq=article-mingci-01&orientation=landscape',
    date: '2026-07-28',
    readTime: '5 分钟',
    content: [
      '很多读者第一次接触《天才医仙漫画》时，会被"真气、通脉、品阶、境界"这些词绕晕。其实这些设定都可以用一句话概括：真气是能量，境界是等级，医术是把能量转化为治疗的能力。',
      '真气可以理解为修行者的"内劲"，是运行炼丹火候、驱动银针的底层能量；境界则是衡量一个人能驾驭多少真气的标尺；而医术体系，就是把这份能量用在治病救人上的方法论。',
      '这样再看炼丹、针灸、功法三大体系就清楚多了：炼丹是"把真气与灵药结合成丹药"，针灸是"用真气引导经脉"，功法则是"积累与运用真气的方法"。三者共享同一套能量逻辑，只是输出形式不同。',
      '掌握了这条底层逻辑，再看任何情节都不会迷路。你会惊讶地发现，漫画里几乎没有"无意义的设定"——每个名词背后都连着医仙之路的一环。',
    ],
  },
  {
    id: 'jing-mai-xue-wei',
    title: '经脉与穴位的漫画化设定：为何针灸是主角的核心技能',
    excerpt:
      '作者把经脉与穴位做了精彩的漫画化处理。本文解析这套视觉设定，并说明为何针灸会成为贯穿主角整条成长线的最强技能。',
    category: '针灸',
    level: '通脉境',
    tag: '经脉穴位',
    cover:
      'https://readdy.ai/api/search-image?query=%E4%BA%BA%E4%BD%93%E7%BB%8F%E8%84%89%E5%85%89%E8%B7%AF%E7%BB%86%E8%85%94%E5%9B%BE%20%E7%8E%89%E9%9D%92%E7%BB%BF%E8%84%89%E7%BB%9C%E7%81%B5%E5%85%89%2C%20%E7%A9%B4%E4%BD%8D%E6%98%8E%E4%BA%AE%E7%82%B9%2C%20%E5%8F%A4%E9%A3%8E%E7%A7%91%E5%B9%BB%E5%9B%BE%E8%A7%A3%2C%20%E5%9B%BD%E7%94%BB%E5%A2%A8%E9%9F%B5%20%E6%9A%96%E9%87%91%E8%89%B2%E5%85%89%E6%99%95&width=800&height=560&seq=article-jingmai-01&orientation=landscape',
    date: '2026-07-24',
    readTime: '7 分钟',
    content: [
      '在《天才医仙漫画》中，经脉与穴位被具象成人体内一张发光的网络。每一条经脉都有清晰的走向，穴位则是网络上的关键节点，针灸正是通过刺激这些节点来改变真气流动。',
      '这种"可视化经脉"的设定，让针灸成为最适合漫画表现的核心技能——读者能直接看到银针引动真气、疏通淤塞的全过程，比抽象的力量描写更有张力。',
      '更重要的是，针灸几乎贯穿主角的所有境界：聚气境用它疗伤，通脉境用它开脉，灵针境则把它升华为攻守一体的绝技。可以说，针灸是连接主角医术与修为的那根主线，其他体系都在为它服务。',
      '理解了"穴位—经脉—真气"这三者如何联动，你就能读懂漫画里几乎每一场针灸戏份的用意，也会明白作者为什么把这项技能放在主角能力的正中央。',
    ],
  },
  {
    id: 'yi-dao-chuan-cheng',
    title: '医道传承：主角拜师、功法来源与医仙门派的势力脉络',
    excerpt:
      '医仙之路离不开师承与门派。本文梳理主角拜师经历、功法来源，以及各大医仙门派之间的势力关系。',
    category: '功法',
    level: '医仙境',
    tag: '医道传承',
    cover:
      'https://readdy.ai/api/search-image?query=%E5%8F%A4%E9%A3%8E%E5%B8%88%E9%97%A8%E5%AE%97%E6%95%99%E5%B1%B1%E9%97%A8%20%E4%BB%99%E4%BA%BA%E5%82%85%E5%B8%88%E5%82%85%E9%81%93%2C%20%E5%B1%B1%E9%97%B4%E4%BA%91%E9%9B%BE%E5%AE%AB%E6%AE%BF%E9%87%8D%E5%B1%82%2C%20%E5%9B%BD%E7%94%BB%E5%A2%A8%E9%9F%B5%20%E6%B8%A9%E6%9A%96%E9%87%91%E8%89%B2%E4%B8%8E%E7%8E%89%E9%9D%92%E7%BB%BF%2C%20%E9%AB%98%E8%A7%84%E6%A0%BC%E6%85%A2%E7%94%BB%E9%A3%8E%E6%A0%BC&width=800&height=560&seq=article-chuancheng-01&orientation=landscape',
    date: '2026-07-20',
    readTime: '8 分钟',
    content: [
      '任何修行体系都离不开"从哪里来"的问题。漫画为医仙之路设计了完整的师承链条：主角从一介凡人开始，经高人点拨入门，再逐步获得传承功法，最终在医仙门派中站稳脚跟。',
      '主角的功法来源并非单一——早期是拜师所得的入门心法，中后期则来自遗迹机缘与门派藏经，越到后面越讲究"医武医道合一"。这让他比同龄人拥有更完整的修炼视野。',
      '医仙门派之间也暗含势力平衡：有的门派重炼丹、垄断高阶灵药；有的门派重针灸、掌握通脉秘术；还有隐世一脉专攻心法传承。主角游走其间，既是医术的受益者，也是打破旧格局的关键变量。',
      '理解传承脉络，能让你看懂很多"为什么主角能学会别人学不会的功法"的情节——背后其实是作者精心铺设的师门与人脉网络在起作用。',
    ],
  },
];

export const featuredArticles: string[] = ['yi-xian-zhi-lu', 'dan-lu-ru-men', 'zhen-jiu-jing-mai', 'gong-fa-jin-jie'];